import { render, staticRenderFns } from "./MPopupStoreHoliday.vue?vue&type=template&id=471f7ded&"
import script from "./MPopupStoreHoliday.ts?vue&type=script&lang=ts&"
export * from "./MPopupStoreHoliday.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports